import React from 'react';
import { LocationRef } from 'gql/autogen/LocationRef';
import { Typography } from '@drone-js/core';
import { Location } from 'gql/autogen/Location';
import { TypographyWhitespacePreWrap } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';

interface Props {
    locationRef: LocationRef;
    locations: Location[];
}

const LocationRefStepper: React.FC<Props> = (props) => {
    if (!props.locationRef.locationRefId || props.locations.length === 0) {
        return null;
    }
    const description = props.locationRef.description;
    const name = props.locations.find((location) => location.id === props.locationRef.locationRefId)?.name;
    return (
        <div data-testid="location-step">
            {name && (
                <Typography mx="4" variant="body-s" textColor="deprecated.secondary.interactive">
                    {name}
                </Typography>
            )}
            {description && (
                <TypographyWhitespacePreWrap mx="4" variant="body-s" textColor="base.subtle">
                    {description}
                </TypographyWhitespacePreWrap>
            )}
        </div>
    );
};
LocationRefStepper.displayName = 'LocationRefStepper';

export default LocationRefStepper;
